














import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import {ImageDto, ImageOrientationDto, PersonDto} from "@swagger";

@Component({
  components: {}
})
export default class PersonSelector extends BasicComponent {

  @Prop(Number) value: number; // The index of the selected person
  @Prop(Array) persons: PersonDto[];

  getPersonPreviewImage(person: PersonDto): ImageDto {
    const images = this.getPersonImages(person);
    const firstLandscape = images.find(image => image.orientation === ImageOrientationDto.LANDSCAPE);
    if (firstLandscape) return firstLandscape;
    return images[0];
  }

  onSelect(index: number): void {
    this.$emit("input", index);
    this.$emit("select");
  }

}

